import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="signatures"
// NOTE: we still need jquery as a dependency of this controller since jsignature is a jquery plugin. bummer
export default class extends Controller {
  static targets = [
    "signature",
    "signatureSvgBase64",
    "signatureNeeded",

    // Allow these elements to be optional.  Instead of defining them as targets,
    // look for them in connect().
    // "includeSpouseSignature",
    // "spouseSignatureContainer",
    // "spouseSignature",
    // "spouseSignatureSvgBase64",
    // "spouseSignatureNeeded",  
  ];

  connect() {
    this.submitting = false;

    // This is a way to get the targets when they exist, and otherwise ignore them.
    this.includeSpouseSignatureTarget = this.element.querySelector('[data-signatures-target="includeSpouseSignature"]');
    this.spouseSignatureContainerTarget = this.element.querySelector('[data-signatures-target="spouseSignatureContainer"]');
    this.spouseSignatureTarget = this.element.querySelector('[data-signatures-target="spouseSignature"]');
    this.spouseSignatureSvgBase64Target = this.element.querySelector('[data-signatures-target="spouseSignatureSvgBase64"]');
    this.spouseSignatureNeededTarget = this.element.querySelector('[data-signatures-target="spouseSignatureNeeded"]');

    // Defer initialization to ensure the browser has computed layout. When
    // Stimulus connect() fires, the element may not have its final dimensions
    // yet (e.g. inside Turbo frames or before CSS is fully applied). If the
    // canvas backing store is created at a tiny size but displayed larger via
    // CSS, every stroke renders as a giant black blob.
    requestAnimationFrame(() => this.initializeSignaturePads())
  }

  initializeSignaturePads() {
    this.initializepad(this.signatureTarget, this.addSvgToForm.bind(this))

    if (this.includeSpouseSignatureTarget && this.includeSpouseSignatureTarget.value === "true") {
      this.initializepad(this.spouseSignatureTarget, this.addSpouseSvgToForm.bind(this))
    }
  }

  initializepad(target, changeHandler) {
    // Read explicit pixel dimensions from the container. We avoid passing
    // percentage-based sizes to jSignature because its internal canvas backing
    // store must match the displayed size exactly — otherwise strokes appear as
    // black blobs. Fall back to sensible defaults if layout hasn't resolved.
    const container = $(target).parent()
    const width = container.width() || 400
    const height = $(target).height() || container.height() || 200

    $(target).jSignature({ height: height, width: width })
    $(target).on('change', changeHandler)
  }

  addSvgToForm(event) {
    var svgData = $(this.signatureTarget).jSignature("getData", "svgbase64")
    this.signatureSvgBase64Target.value = svgData
    // this doesn't necessarily trigger a change on the hidden element, so do it manually
    this.signatureSvgBase64Target.dispatchEvent(new Event("change"))
  }

  addSpouseSvgToForm(event) {
    var svgData = $(this.spouseSignatureTarget).jSignature("getData", "svgbase64")
    this.spouseSignatureSvgBase64Target.value = svgData
    // this doesn't necessarily trigger a change on the hidden element, so do it manually
    this.spouseSignatureSvgBase64Target.dispatchEvent(new Event("change"))
  }

  clearSignature() {
    $(this.signatureTarget).jSignature("reset")
    this.signatureSvgBase64Target.value = ""
    // Notify listeners (e.g. the review-gate controller) that the signature is now empty.
    this.signatureSvgBase64Target.dispatchEvent(new Event("change"))
    //this.signatureNeededTarget.classList.add("hidden");
  }

  clearSpouseSignature() {
    $(this.spouseSignatureTarget).jSignature("reset")
    this.spouseSignatureSvgBase64Target.value = ""
    //this.spouseSignatureNeededTarget.classList.add("hidden");
  }

  onHaveSpouseChange(e) {
    // There's a limitation in height animations, which is nothing to do with Tailwind, just CSS.
    // If you want to animate, you have to have a specific start and end size.  To make this happen
    // We use an arbitrarily large max-height which should be big enough to accommodate the content.
    this.spouseSignatureContainerTarget.classList.toggle("max-h-0");
    this.spouseSignatureContainerTarget.classList.toggle("max-h-[1000px]");
  }

  onSubmit(e) {
    e.preventDefault();

    // Guard against double-submission
    if (this.submitting) {
      console.log('Signature form already submitting, ignoring duplicate click');
      return;
    }

    // Ensure the user signed (avoid empty signatures)
    var data = $(this.signatureTarget).jSignature("getData", "native");
    // The returned value is an array of strokes.  If it's empty, it means the user didn't sign at all.
    // https://willowsystems.github.io/jSignature/#/about/
    if (data.length == 0) {
      this.signatureNeededTarget.classList.remove("hidden");
      this.signatureNeededTarget.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    } else {
      this.signatureNeededTarget.classList.add("hidden");
      this.addSvgToForm(e);
    }

    if (this.includeSpouseSignatureTarget && this.includeSpouseSignatureTarget.value === "true" && this.element['have_spouse'] && this.element['have_spouse'].checked) {
      // Ensure the spouse signed too (avoid empty signatures)
      var data = $(this.spouseSignatureTarget).jSignature("getData", "native");
      if (data.length == 0) {
        this.spouseSignatureNeededTarget.classList.remove("hidden");
        this.spouseSignatureNeededTarget.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      } else {
        this.spouseSignatureNeededTarget.classList.add("hidden");
        this.addSpouseSvgToForm(e);
      }
    }

    // Mark as submitting and disable the button
    this.submitting = true;
    const submitButton = e.currentTarget;
    submitButton.disabled = true;
    submitButton.classList.add('opacity-50', 'cursor-not-allowed');

    this.element.submit();
  }
}
